import React from "react";

const WizardMigrateList = () => {
  return (
    <div>
      <div>
        <div>
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  {/* <h1 className="page-title">Vehicle Model</h1> */}
                </div>

                <div className="col-sm-6"></div>
              </div>
            </div>
            {/* /.container-fluid */}
          </section>

          <section className="content">
            <div className="container-fluid container-custom-height-new">
              <div className="row">
                <div className="col-md-12">
                  <div className="card fuelCard">
                    <div className="card-header">
                      <div
                        className="card-title m-0 float-left fuelCT"
                        style={{ width: "60%" }}
                      >
                        <span className="badge bg-primary">{("step")} 2 of 3</span>
                      </div>
                    </div>
                    <div className="card-body text-center">
                      <p className="mb-3">
                        Get Started: Watch this video to learn how migration
                        works
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default WizardMigrateList;
